import base64 from "base-64"

export default function CloudImg(props) {
    console.log(props.src);
    if ( props.src.includes(".gif") ) {
      const newURL = "https://img.2fivefive.xyz/" + props.src;
      const newProps = {...props, src:newURL}
      return (<img { ...newProps } />);
    }

    const endpoint = "https://dcyq1b498jmt.cloudfront.net/";

    const cloudRequest = {
        bucket: "img.2fivefive.xyz",
        key: props.src,
        edits: {
            resize: {
                fit: "outside",
                width: 400,
                height: 400
            }
        }
    };

    const newURL = endpoint + base64.encode(JSON.stringify(cloudRequest));
    const newProps = {...props, src:newURL}

    return (<img {...newProps} />);
}
